export default {
  navbar: {
    home: 'Ana Sayfa',
    jobs: 'İşler',
    companies: 'Şirketler',
    about: 'Hakkımızda',
    customerService: 'Müşteri Hizmetleri',
    signIn: 'Giriş Yap',
    register: 'Kayıt Ol'
  },
  customerService: {
    title: 'Müşteri Hizmetleri',
    subtitle: 'Profesyonel destek ekibimiz 24/7 sorularınızı yanıtlamak için burada.',
    onlineService: 'Çevrimiçi Hizmet',
    serviceDescription: 'Profesyonel destek ekibimiz 24/7 hazır.',
    startChat: 'Çevrimiçi Sohbet Başlat',
    responseTime: 'Ortalama yanıt süresi: 30 saniye',
    instantResponse: 'Anında Yanıt',
    instantResponseDesc: 'Müşteri hizmetleri ekibimiz 24/7 çevrimiçi, ortalama yanıt süresi 2 dakikadan az',
    professionalTeam: 'Profesyonel Ekip',
    professionalTeamDesc: 'Tüm iş süreçlerine aşina, titizlikle eğitilmiş müşteri hizmetleri personeli',
    securityPrivacy: 'Güvenlik ve Gizlilik',
    securityPrivacyDesc: 'Tüm bilgileriniz mutlak güvenliği sağlamak için şifrelenmiştir',
    serviceOnline: 'Hizmet Çevrimiçi',
    seniorConsultant: 'Kıdemli Müşteri Danışmanı'
  },
  home: {
    heroTitle: 'Sinema sektöründe hayalinizdeki işi bulun',
    heroSubtitle: 'En iyi sinema ve eğlence şirketleriyle bağlantı kurun. Bugünden heyecan verici sinema dünyasında yolculuğunuza başlayın.',
    popularCategories: 'Popüler İş Kategorileri',
    categoriesDescription: 'Çeşitli sinema ve eğlence alanlarında fırsatları keşfedin',
    featuredJobOpportunities: 'Öne Çıkan İş Fırsatları',
    discoverLatestOpenings: 'En iyi sinemalardaki en son açık pozisyonları keşfedin',
    openPositions: 'açık pozisyon',
    quickApply: 'Hızlı Başvuru',
    whyChooseUs: 'Neden Bizi Seçmelisiniz',
    joinLargestNetwork: 'En büyük sinema profesyonelleri ağına katılın',
    categories: {
      theaterOperations: {
        title: 'Sinema Operasyonları',
        description: 'Günlük sinema operasyonlarını yönetin ve sorunsuz gösterimleri sağlayın'
      },
      boxOfficeManagement: {
        title: 'Büfe Yönetimi',
        description: 'Büfede bilet satışlarını ve müşteri hizmetlerini yönetin'
      },
      cinemaTechnology: {
        title: 'Sinema Teknolojisi',
        description: 'Gelişmiş sinema ekipmanı ve sistemlerini koruyun ve çalıştırın'
      },
      customerService: {
        title: 'Müşteri Hizmetleri',
        description: 'Sinema izleyicilerine mükemmel hizmet sunun'
      },
      foodBeverage: {
        title: 'Yiyecek & İçecek',
        description: 'Atıştırmalık standı ve yiyecek hizmeti operasyonlarını yönetin'
      },
      marketingPromotions: {
        title: 'Pazarlama & Tanıtım',
        description: 'Sinemalar için pazarlama stratejileri oluşturun ve uygulayın'
      }
    },
    featuredJobs: {
      theaterManager: {
        title: 'Sinema Müdürü',
        company: 'AMC Sinemaları',
        location: 'New York, NY',
        type: 'Tam Zamanlı',
        salary: '$65K - $85K',
        benefit: 'Faydalar'
      },
      digitalProjectionist: {
        title: 'Dijital Projeksiyonist',
        company: 'Regal Sinemaları',
        location: 'Los Angeles, CA',
        type: 'Tam Zamanlı',
        salary: '$45K - $60K',
        benefit: 'Eğitim'
      },
      marketingCoordinator: {
        title: 'Pazarlama Koordinatörü',
        company: 'Cinemark',
        location: 'Chicago, IL',
        type: 'Tam Zamanlı',
        salary: '$50K - $65K',
        benefit: 'Uzaktan'
      }
    },
    features: {
      largeIndustryNetwork: {
        title: 'Büyük Endüstri Ağı',
        description: 'Dünya çapında 2.500+ sinema ve eğlence şirketiyle bağlantı kurun',
        stat: '15.000+ aktif kullanıcı'
      },
      verifiedEmployers: {
        title: 'Doğrulanmış İşverenler',
        description: 'Tüm işverenler gerçek fırsatları garanti etmek için sıkı bir şekilde incelenir',
        stat: '%100 doğrulanmış şirketler'
      },
      careerGrowth: {
        title: 'Kariyer Gelişimi',
        description: 'Eğitim kaynaklarına ve terfi fırsatlarına erişin',
        stat: '%89 başarı oranı'
      }
    }
  },
  jobs: {
    heroTitle: 'Sinema Ailemize Katılın',
    heroSubtitle: 'Hikayeleri hayata geçiren sihrin bir parçası olun. Büyüyen ekibimize katılmak için tutkulu insanlar arıyoruz.',
    viewPositions: 'Açık Pozisyonları Gör',
    currentOpenings: 'Mevcut Açık Pozisyonlar',
    department: 'Departman',
    location: 'Konum',
    applyNow: 'Hemen Başvur',
    whyJoinUs: 'Neden Bize Katılmalısınız',
    ourCulture: 'Kültürümüz',
    applicationProcess: 'Başvuru Süreci',
    startYourJourney: 'Yolculuğunuza Başlayın',
    benefits: {
      freeMovieAccess: {
        title: 'Ücretsiz Filmler',
        description: 'Siz ve aileniz için sınırsız ücretsiz filmlerin keyfini çıkarın.'
      },
      careerGrowth: {
        title: 'Kariyer Gelişimi',
        description: 'Kapsamlı eğitim ve net kariyer ilerleme yolları.'
      },
      flexibleSchedule: {
        title: 'Esnek Çizelge',
        description: 'İş-hayat dengesi için esnek çizelge seçenekleri.'
      }
    },
    jobList: [
      {
        title: 'Sinema Operasyonları Müdürü',
        location: 'New York, NY',
        type: 'Tam Zamanlı',
        description: 'Amiral gemimizde günlük sinema operasyonlarını yönetin ve müşteri hizmetlerinde mükemmelliği sağlayın.'
      },
      {
        title: 'Kıdemli Projeksiyonist',
        location: 'Los Angeles, CA',
        type: 'Tam Zamanlı',
        description: 'En iyi izleme deneyimini sağlamak için dijital projeksiyon sistemlerini çalıştırın ve koruyun.'
      },
      {
        title: 'Atıştırmalık Takım Lideri',
        location: 'Chicago, IL',
        type: 'Tam Zamanlı',
        description: 'Atıştırmalık standı operasyonlarını yönetin ve profesyonel bir yiyecek hizmeti ekibine liderlik edin.'
      },
      {
        title: 'Misafir Deneyimi Uzmanı',
        location: 'Miami, FL',
        type: 'Yarı Zamanlı',
        description: 'Mükemmel hizmet sunun ve misafirlerimiz için unutulmaz deneyimler yaratın.'
      },
      {
        title: 'Teknik Destek Uzmanı',
        location: 'Seattle, WA',
        type: 'Tam Zamanlı',
        description: 'Sinema ekipmanı ve sistemlerini koruyun ve sorunları giderin.'
      },
      {
        title: 'Etkinlik Koordinatörü',
        location: 'Boston, MA',
        type: 'Tam Zamanlı',
        description: 'Özel gösterimler ve özel sinema etkinlikleri planlayın ve uygulayın.'
      }
    ],
    testimonials: [
      {
        name: 'Emily Richardson',
        position: 'Sinema Müdürü',
        quote: 'Burada çalışmak inanılmaz bir yolculuktu. Büyüme fırsatları ve destekleyici ortam, burayı sadece bir işten daha fazlası yapıyor.'
      },
      {
        name: 'Michael Anderson',
        position: 'Kıdemli Projeksiyonist',
        quote: 'Beraber çalıştığımız teknoloji ve ekipman birinci sınıf. Herhangi bir filmsever için bu gerçekleşmiş bir rüya.'
      },
      {
        name: 'Sarah Martinez',
        position: 'Etkinlik Koordinatörü',
        quote: 'Buradaki ekip çalışması şaşırtıcı. Misafirlerimiz için unutulmaz deneyimler yaratmak için birlikte çalışıyoruz.'
      }
    ],
    applicationSteps: [
      {
        title: 'Çevrimiçi Başvuru',
        description: 'Kariyer portalımız üzerinden başvurunuzu gönderin.'
      },
      {
        title: 'İlk İnceleme',
        description: 'Ekibimiz başvurunuzu 48 saat içinde inceleyecektir.'
      },
      {
        title: 'Mülakat',
        description: 'Fırsatı tartışmak için ekibimizle buluşun.'
      },
      {
        title: 'Hoş Geldiniz',
        description: 'Sinema ailemizle yolculuğunuza başlayın.'
      }
    ]
  },
  companies: {
    searchPlaceholder: 'Şirket ara...',
    location: 'Konum',
    companySize: 'Şirket Büyüklüğü',
    industry: 'Sektör',
    openPositions: 'açık pozisyon',
    viewJobs: 'İşleri Gör',
    loadMore: 'Daha Fazla Şirket Yükle',
    companyList: [
      {
        name: 'Universal Entertainment Group',
        location: 'Los Angeles, CA',
        size: '5.000+ çalışan',
        description: 'Dünya çapında film ve televizyon içeriği üreten ve dağıtan önde gelen küresel eğlence şirketi.'
      },
      {
        name: 'Cinemark Productions',
        location: 'New York, NY',
        size: '2.000-5.000 çalışan',
        description: 'Büyük bütçeli filmlerde ve yenilikçi dijital içerikte uzmanlaşmış ödüllü yapım stüdyosu.'
      },
      {
        name: 'Digital Cinema Solutions',
        location: 'San Francisco, CA',
        size: '1.000-2.000 çalışan',
        description: 'Yenilikçi çözümlerle dijital sinema deneyimini devrimleştiren teknoloji odaklı şirket.'
      },
      {
        name: 'Paramount Digital Studios',
        location: 'Chicago, IL',
        size: '500-1.000 çalışan',
        description: 'Son teknoloji ile yeni nesil dijital eğlence deneyimleri yaratıyor.'
      },
      {
        name: 'Global Theater Networks',
        location: 'Miami, FL',
        size: '1.000-2.000 çalışan',
        description: 'Büyük şehirlerde son teknoloji tesislere sahip premium sinema zincirlerini işletiyor.'
      },
      {
        name: 'Silverscreen Technologies',
        location: 'Seattle, WA',
        size: '500-1.000 çalışan',
        description: 'Modern sinema endüstrisi için son teknoloji yazılım çözümleri geliştiriyor.'
      }
    ]
  },
  about: {
    heroTitle: 'Hakkımızda',
    heroSubtitle: 'Yaratıcılıkla teknolojinin buluştuğu yerde, yenilikçi lensler aracılığıyla hikayeler hayat buluyor.',
    ourStory: 'Hikayemiz',
    storyParagraph1: 'CineMaster Studio 2010 yılında kuruldu ve on yıldan fazla bir süredir sinema yeniliğinin ön saflarında yer alıyor. Yolculuğumuz basit ama güçlü bir vizyonla başladı: dünya çapında izleyicilerle rezonansa giren çekici görsel hikayeler yaratmak.',
    storyParagraph2: 'Bugün, global markalarla ve sektörün yetenekli sanatçılarıyla işbirliği yapan önde gelen yapım stüdyolarından biri olmaktan gurur duyuyoruz. Mükemmeliyete bağlılığımız ve hikaye anlatma tutkumuz bizi ileriye taşımaya devam ediyor.',
    ourCoreValues: 'Temel Değerlerimiz',
    creativeExcellence: 'Yaratıcı Mükemmellik',
    creativeExcellenceDesc: 'Sınırları zorlayın ve görsel anlatımda yeni standartlar belirleyin.',
    collaborativeSpirit: 'İşbirliği Ruhu',
    collaborativeSpiritDesc: 'Benzersiz vizyonları hayata geçirmek için birlikte çalışın.',
    qualityFirst: 'Kalite Öncelikli',
    qualityFirstDesc: 'Yarattığımız her karede mükemmelliği hedefleyin.',
    meetOurTeam: 'Ekibimizle Tanışın',
    creativeDirector: 'Yaratıcı Direktör',
    leadCinematographer: 'Baş Sinematograf',
    technicalDirector: 'Teknik Direktör',
    productionManager: 'Yapım Müdürü',
    yearsExperience: 'yıllık deneyim',
    projectsCompleted: 'tamamlanan proje',
    industryAwards: 'endüstri ödülü',
    happyClients: 'mutlu müşteri'
  },
  footer: {
    copyright: '© 2025 TJH - Ticket Job Hub. Tüm hakları saklıdır.',
    description: 'Sinema sektöründe yetenekleri fırsatlarla buluşturuyoruz. Sinema operasyonları, yönetim veya teknoloji pozisyonlarında bir sonraki rolünüzü bulun.',
    quickLinks: 'Hızlı Bağlantılar',
    jobSeeker: 'İş Arayan',
    newsletter: 'Bülten',
    newsletterText: 'En son iş güncellemelerini ve kariyer tavsiyelerini almak için abone olun.',
    emailPlaceholder: 'E-posta adresiniz',
    subscribe: 'Abone Ol',
    quickLinksList: ['Hakkımızda', 'İletişim', 'Gizlilik Politikası', 'Kullanım Şartları'],
    jobSeekerLinksList: ['İşleri Keşfet', 'Kariyer Kaynakları', 'Özgeçmiş İpuçları', 'İş Uyarıları']
  }
}